var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5C10.0899 5 13 3.88071 13 2.5C13 1.11929 10.0899 0 6.5 0C2.91015 0 0 1.11929 0 2.5C0 3.88071 2.91015 5 6.5 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2759 5C10.7536 5.84138 8.5839 6.24138 6.5 6.24138C4.4161 6.24138 2.2464 5.84138 0.7241 5C0.2769 5.37517 0 5.7931 0 6.24138C0 7.76552 2.9107 9 6.5 9C10.0893 9 13 7.76552 13 6.24138C13 5.7931 12.7231 5.37517 12.2759 5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2759 9C10.7536 9.84138 8.5839 10.2414 6.5 10.2414C4.4161 10.2414 2.2464 9.84138 0.7241 9C0.2769 9.37517 0 9.7931 0 10.2414C0 11.7655 2.9107 13 6.5 13C10.0893 13 13 11.7655 13 10.2414C13 9.7931 12.7231 9.37517 12.2759 9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2759 13C10.7536 13.8414 8.5839 14.2414 6.5 14.2414C4.4161 14.2414 2.2464 13.8414 0.7241 13C0.2769 13.3752 0 13.7931 0 14.2414C0 15.7655 2.9107 17 6.5 17C10.0893 17 13 15.7655 13 14.2414C13 13.7931 12.7231 13.3752 12.2759 13Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/icon-volume.01f658e7.svg";
export { ForwardRef as ReactComponent };